import React from 'react';
import { Box } from 'react-components';
import { privacyPolicyUrl } from 'shared/globals';

export const PrivacyPage: React.FunctionComponent = () => {
  return (
    <Box height="100vh" mt="6rem">
      <iframe style={{ height: '100%', width: '100%' }} src={privacyPolicyUrl}></iframe>
    </Box>
  );
};
